import React from 'react';
import { StethoscopeIcon, SunIcon, BeefIcon, MoonIcon, AppleIcon, ShoppingCartIcon, CheckIcon, BookOpenIcon } from 'lucide-react';
import { tomos, tomoChecklist } from '../data/tomos';
const icons = {
  stethoscope: StethoscopeIcon,
  sun: SunIcon,
  beef: BeefIcon,
  moon: MoonIcon,
  apple: AppleIcon,
  cart: ShoppingCartIcon
};
export function TomosSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="tomos-title" data-id="element-320" data-mp="xcw3zht51dra">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-321" data-mp="11dpt2eibgylr">
        <div className="flex items-start gap-4" data-id="element-322" data-mp="11e9cjznm7v1w">
          <BookOpenIcon className="mt-1.5 h-8 w-8 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-323" data-mp="16cj8wdl2t1p3" />
          <h2 id="tomos-title" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl lg:text-5xl" data-id="element-324" data-mp="1bbvr2l105klc">
            Los 6 Tomos — el camino completo, resuelto de una vez
          </h2>
        </div>

        <ol className="mt-12 space-y-6" data-id="element-325" data-mp="2mt5efin94wrx">
          {tomos.map(tomo => {
          const Icon = icons[tomo.icon];
          return <li key={tomo.number} className="grid gap-6 rounded-2xl border-l-4 border-sage bg-white px-6 py-8 shadow-sm sm:px-10 md:grid-cols-[minmax(0,12rem)_minmax(0,1fr)] md:gap-10" data-id="element-326" data-mp="2mmdhucyxzb3t">
                <div data-id="element-327" data-mp="2co7leavwmx6c">
                  <span className="inline-block rounded-full bg-petrol px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.12em] text-white" data-id="element-328" data-mp="2cqttqcqmdgpm">
                    Tomo {tomo.number}
                  </span>
                  <Icon className="mt-5 hidden h-10 w-10 text-sage-deep md:block" aria-hidden="true" data-id="element-329" data-mp="1ywsyvu2sgduj" />
                </div>
                <div data-id="element-330" data-mp="1tz0yebo2vjeq">
                  <h3 className="font-display text-xl font-bold leading-snug text-petrol sm:text-2xl" data-id="element-331" data-mp="1tzj3lxspx7ys">
                    {tomo.title}
                  </h3>
                  <div className="mt-4 space-y-3 text-base leading-relaxed text-body" data-id="element-332" data-mp="1jza4ab3fj6f6">
                    {tomo.paragraphs.map(paragraph => <p key={paragraph} data-id="element-333" data-mp="1aav1ioajw1wi">{paragraph}</p>)}
                  </div>
                  <p className="mt-5 font-display text-lg font-bold leading-snug text-petrol" data-id="element-334" data-mp="1fckewal8wrnr">
                    {tomo.closing}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mt-12 rounded-3xl border border-sage/30 bg-sage-soft px-6 py-8 sm:px-10 sm:py-10" data-id="element-335" data-mp="1t2nre9ubp700">
          <h3 className="font-display text-xl font-bold text-petrol sm:text-2xl" data-id="element-336" data-mp="1y1h7ma0zvc3v">Cada tomo incluye:</h3>
          <ul className="mt-6 grid gap-x-10 gap-y-3.5 md:grid-cols-2" data-id="element-337" data-mp="1kavnkhzt0w4e">
            {tomoChecklist.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-body" data-id="element-338" data-mp="1ob5vi075pwlw">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-339" data-mp="2c107kfjnjh53" />
                <span data-id="element-340" data-mp="2gsrtgcrv4yow">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}